export const DisplayOnCardPill = () => {
  return (
    <div className="rounded-full px-2 py-0.5 bg-[#ff352d0d] w-fit">
      <p className="text-[#ff352d] font-medium text-xs truncate">
        Displayed on Card
      </p>
    </div>
  );
};
